import React from 'react';
import { Paper, IconButton, Grow, Link } from '@mui/material';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';

const selectExtIcon = (fileName) => {
  const extension = fileName.split('.').pop();

  if (extension === 'jpg' || extension === 'png')
    return <ImageRoundedIcon sx={{ color: '#ffb2e1' }} />;
  if (extension === 'pdf')
    return <PictureAsPdfRoundedIcon sx={{ color: 'rgba(205, 0, 0, 0.6)' }} />;
  return <InsertDriveFileRoundedIcon sx={{ color: '#579ff3' }} />;
};

const FilePaper = function FilePaper({ fileName, onClick, onClickIcon, type }) {
  return (
    <Grow in>
      <Paper square elevation={3} sx={{ width: '10vw' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 3,
              overflow: 'hidden',
            }}
          >
            {selectExtIcon(fileName)}
            <Link
              // href={path}
              onClick={() => {
                const method = type === 'pdf' ? 'preview' : 'download';
                onClick(fileName, method);
              }}
              underline="hover"
              variant="body1"
              noWrap
              sx={{
                textOverflow: 'ellipsis',
                cursor: 'pointer',
              }}
            >
              {fileName}
            </Link>
          </div>
          <IconButton onClick={() => onClick(fileName, 'download')}>
            {onClickIcon}
          </IconButton>
        </div>
      </Paper>
    </Grow>
  );
};

export default FilePaper;
